/* eslint-disable no-unused-vars */
import React, { useContext, useEffect, useState } from 'react'
import { StoreContext } from '../context/context'
import MonthCards from './monthComponents/MonthCards'
import MonthTable from './monthComponents/MonthTable'
import MonthSales from './monthComponents/MonthSales'
const MonthStats = () =>{ 

    const {users, counters} = useContext(StoreContext)
    const [data,setData] = useState()
    const [usersDay, setUsersDay] = useState([])
    const current = new Date ()
    current.setDate(current.getDate()-1)
    useEffect(()=>{
        setData(counters?.daily)
        console.log('data daily',counters.daily)
    },[counters])

    useEffect(()=>{
        setUsersDay(users.filter(user=> new Date(user.created_at).getDay() === new Date (current).getDay() && new Date (user.created_at).getFullYear() === new Date ().getFullYear()))
    },[counters,data])


    return (
        <div>
            <div className="flex w-full">
                <div className="w-full mb-6 lg:mb-0">
                    <h1 className="sm:text-3xl text-4xl font-medium title-font mb-2 text-blue">Statistic {current.toLocaleString('default', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}</h1>
                    <div className="h-1 w-20 bg-indigo-500 rounded"></div>
                </div>
            </div>
            <div className="flex flex-col justify-center">
                <MonthCards usersMonth={usersDay} newLicensesMonth={counters.daily?.data[0]?.data?.newLicenses?.data[0]+ counters.daily?.data[0]?.data?.newTopupLicenses?.data[0]} totalPointsMonth={counters.daily?.data[0]?.data?.newLicensesAvailablePoints?.data[0]} totalPointsUsedMonth={counters.daily?.data[0]?.data?.newLicensesUsedPoints?.data[0]} />
                <div className="grid grid-cols-1 lg:grid-cols-2">
                    <MonthTable expiredAvailablePoints={counters.daily?.data[0]?.data?.expiredAvailablePoints?.data[0]} expiredPoints={counters.daily?.data[0]?.data?.expiredPoints?.data[0]} expiredLicensesMonth={counters.daily?.data[0]?.data?.expiredLicenses?.data[0]}/>
                    <MonthSales monthSalesExpired={counters.daily?.data[0]?.data?.expiredPrices?.data[0]} monthSales={counters.daily?.data[0]?.data?.newLicensesPrice?.data[0]} />
                </div>
    
            </div>
 
        </div>

    )
}
export default MonthStats